import { createFileRoute } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { EditPaymentTermContainer } from "@/screens/Accounting/subfeatures/PaymentTerms"

export const Route = createFileRoute("/app/admin/accounting/payment-term/$paymentTermId")({
  component: () => (
    <PermissionContentWrapper
      permissions={[PermissionActionType.ACCOUNTING_MANAGER, PermissionActionType.ACCOUNTING_MAINTENANCE]}
    >
      <EditPaymentTermContainer />
    </PermissionContentWrapper>
  ),
})
